import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useMissionTask } from "../../../../providers/MissionTaskProvider";
import { makeStyles } from "tss-react/mui";
import { useDevice } from "../../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    isMobilePortraitView: {
      "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
      },
      "& h2.MuiTypography-root.MuiDialogTitle-root": {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        lineHeight: "125%"
      },
      "& .MuiDialogActions-root": {
        padding: theme.spacing(1.5),
        paddingTop: 0,
        paddingBottom: theme.spacing(1),
        flexDirection: "column-reverse",
        "& > button": {
          border: "1px solid black",
          width: `calc(100% - ${theme.spacing(1)})`,
          margin: 0,
          marginBottom: theme.spacing(1),
          padding: theme.spacing(1),
          flex: 1,
        }
      }
    }
  })
);

export default function NavigationArrivedDialog(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { continueMission, continueMissionText } = useMissionTask();
  const { isMobilePortraitView } = useDevice();

  const onCancel = () => {
    navigate("../", { relative: "path", replace: true });
  };

  const onConfirm = () => {
    continueMission();
    setTimeout(() => {
      navigate("../", { relative: "path", replace: true });
    }, 10);
  };

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      onClose={props.onClose}
      className={`${isMobilePortraitView ? classes.isMobilePortraitView : ""}`}
    >
      <DialogTitle id="alert-dialog-title">
        {t("task:navArrivedDialog:title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("task:navArrivedDialog:description")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onCancel} autoFocus size="large">
          {t("task:navArrivedDialog:cancel")}
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm} autoFocus size="large">
          {continueMissionText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}